import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatDate} from "../util/helpers";

export default function PaymentMain() {
    const [pager, setPager] = useState();
    const [results, setResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("page") || '1';
    const chatRoomId = searchParams.get("chatRoomId") || '';
    const status = searchParams.get("status") || '';

    const requestData = () => {
        const params = {};
        params.page = page;
        if (chatRoomId) params.chatRoomId = chatRoomId;
        if (status) params.status = status;
        axios.get(`/admin/v1/payments`, { params })
            .then((res) => {
                setPager(res.data);
                setResults(res.data.content || []);
            });
    };

    const setPage = (value) => {
        searchParams.set("page", value);
        setSearchParams(searchParams);
    };

    const search = () => {
        setPage(1);
        requestData();
    };

    useEffect(() => {
        requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, chatRoomId, status]);

    const displayPaymentStatus = (status, settlementDueAt, settlementAt) => {
        if (status === 'PAID' && settlementAt !== null) {
            return '지급 확정'
        }
        if (status === 'PAID' && settlementDueAt !== null) {
            return '지급 대기'
        }
        switch (status) {
            case 'PAID': return '결제 완료';
            case 'PARTIAL_CANCEL': return '부분 지급';
            case 'CANCELLED': return '지급 취소';
            default: return status;
        }
    };

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">결제관리 &gt; 결제 이력</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>
                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>매칭ID</label>
                                                <input type="text" className="form-control float-right"
                                                       style={{width: '160px', marginRight: '20px'}}
                                                       placeholder="매칭ID로 검색"
                                                       value={chatRoomId}
                                                       onChange={e => {
                                                           searchParams.set("page", '1');
                                                           searchParams.set("chatRoomId", e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               e.preventDefault();
                                                               search();
                                                           }
                                                       }}
                                                />

                                                <label className="col-sm-auto col-form-label" style={{marginLeft: '10px'}}>결제상태</label>
                                                <select className="form-control float-right"
                                                        style={{width: '180px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set("page", '1');
                                                            searchParams.set("status", e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={status}>
                                                    <option value="">모두</option>
                                                    <option value="PAID">결제 완료</option>
                                                    <option value="PARTIAL_CANCEL">부분 환불</option>
                                                    <option value="CANCELLED">전체 환불</option>
                                                    <option value="ESCROW">정산 대기</option>
                                                    <option value="SETTLED">정산 완료</option>
                                                </select>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginRight: '10px'}}
                                                        onClick={search}>
                                                    검색
                                                </button>
                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap" style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>결제ID</th>
                                                    <th>매칭ID</th>
                                                    <th>매칭 일시</th>
                                                    <th>결제 일시</th>
                                                    <th>결제 상태</th>
                                                    <th>상세보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {results && results.map(item => (
                                                    <tr key={item.id}>
                                                        <td>{item.id}</td>
                                                        <td>
                                                            <a href={`/page/chat/detail?id=${item.chatRoomId}`}
                                                               target="_blank"
                                                               rel="noopener noreferrer">{item.chatRoomId}</a>
                                                        </td>
                                                        <td>{formatDate(item.chatCreatedAt)}</td>
                                                        <td>{formatDate(item.paidAt)}</td>
                                                        <td>{displayPaymentStatus(item.status, item.settlementDueAt, item.settlementAt)}</td>
                                                        <td>
                                                            <Link to={`/page/payments/detail?id=${item.id}`} className="btn btn-outline-info">
                                                                보기
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {pager && <Pagination pager={pager} setPage={setPage} />}

                    </section>
                </div>
            </div>
        </div>
    );
}
